// Partagés avec l'aperçu du Drawer (cf. tableCellStyle).
export {
  DEFAULT_TABLE_CUSTOM_PADDING,
  TABLE_PADDING_UNITS,
  resolveCustomPadding,
  cellTextColor,
} from '../shared/tables/tableCellStyle';

// Police des cellules quand aucune n'est réglée, pour convertir de l'em en px.
const FALLBACK_FONT_SIZE = 16;

// Taille en px d'une unité : `em` suit la police des cellules.
const pxPerUnit = (unit, cellFontSize) =>
  (unit === 'em' ? Number(cellFontSize) || FALLBACK_FONT_SIZE : 1);

export const paddingToPx = (value, unit, cellFontSize) =>
  value * pxPerUnit(unit, cellFontSize);

// Change l'unité d'un espacement sans le changer à l'écran : 8px à 12px de
// police font 0,67em.
export const convertPaddingUnit = (value, from, to, cellFontSize) => {
  const converted = paddingToPx(value, from, cellFontSize) / pxPerUnit(to, cellFontSize);
  return to === 'px' ? Math.round(converted) : Math.round(converted * 100) / 100;
};

export const rowStyleForComponent = (tableStyle, rowIndex) => {
  const bgColor =
    tableStyle?.stripped1 && !tableStyle?.customCellColorBool
      ? rowIndex % 2 === 0
        ? tableStyle.strippedCustomClr1.style
        : tableStyle.strippedCustomClr2.style
      : tableStyle.stripped1;
  return {
    backgroundColor: bgColor,
  };
};

export const tableStyleForComponent = (tableStyle, configuration) => {
  const { bordered, footer, footerData, size, showHeader } = tableStyle;
  return {
    bordered,
    footer: footer
      ? () => {
          return (
            <div
              style={{
                fontSize: tableStyle?.fontSizeCells || configuration.fontSize,
                fontFamily:
                  tableStyle?.fontFamilyCells || configuration.fontFamily,
              }}
            >
              {footerData}
            </div>
          );
        }
      : null,
    size,
    showHeader,
  };
};
